import PlusCircle from "@/assets/icons/plus-circle.svg?react";
import { validateAndHandleFile } from "@endya-conformite/ui-kit";
import classNames from "classnames";
import styles from "./FileUploadButton.module.scss";

const ACCEPTED_FILE_TYPES = ["application/pdf"];

export function FileUploadButton({
  onChange,
  disabled = false,
}: {
  onChange: (file: File) => void;
  disabled?: boolean;
}) {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    validateAndHandleFile(e.target.files?.[0], ACCEPTED_FILE_TYPES, onChange);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (disabled) return;
    validateAndHandleFile(
      e.dataTransfer.files?.[0],
      ACCEPTED_FILE_TYPES,
      onChange
    );
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  return (
    <div onDrop={handleDrop} onDragOver={handleDragOver}>
      <input
        type="file"
        accept="application/pdf"
        onChange={handleFileChange}
        className={styles.fileInput}
        id="file-upload"
        disabled={disabled}
      />
      <label
        htmlFor="file-upload"
        className={classNames(styles.uploadButton, {
          [styles.disabled]: disabled,
        })}
        aria-disabled={disabled}
      >
        <PlusCircle />
        <span>Déposer votre rapport en PDF</span>
      </label>
    </div>
  );
}
